import React from 'react';
import {TreesGame} from "./trees-game-1";

export default {
    'trees-game-1': <TreesGame />,
}